{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://schemas.fortemi.dev/knowledge-shard/1.2.0/full-v1/skos-scheme.schema.json",
  "title": "Fortemi Knowledge Shard full-v1 SKOS concept scheme",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "id", "uri", "notation", "title", "description", "creator", "publisher",
    "rights", "version", "is_active", "is_system", "created_at", "updated_at",
    "issued_at", "modified_at", "embedding", "embedding_model", "embedded_at"
  ],
  "properties": {
    "id": { "type": "string", "format": "uuid" },
    "uri": { "type": ["string", "null"], "format": "uri" },
    "notation": { "type": "string", "minLength": 1 },
    "title": { "type": "string", "minLength": 1 },
    "description": { "type": ["string", "null"] },
    "creator": { "type": ["string", "null"] },
    "publisher": { "type": ["string", "null"] },
    "rights": { "type": ["string", "null"] },
    "version": { "type": ["string", "null"] },
    "is_active": { "type": "boolean" },
    "is_system": { "type": "boolean" },
    "created_at": { "type": "string", "format": "date-time" },
    "updated_at": { "type": "string", "format": "date-time" },
    "issued_at": { "type": ["string", "null"], "format": "date-time" },
    "modified_at": { "type": ["string", "null"], "format": "date-time" },
    "embedding": {
      "type": ["array", "null"],
      "minItems": 768,
      "maxItems": 768,
      "items": { "type": "number" }
    },
    "embedding_model": { "type": ["string", "null"], "minLength": 1 },
    "embedded_at": { "type": ["string", "null"], "format": "date-time" }
  }
}
